import { render, staticRenderFns } from "./Modifypackage.vue?vue&type=template&id=0f3527ed"
import script from "./Modifypackage.vue?vue&type=script&lang=js"
export * from "./Modifypackage.vue?vue&type=script&lang=js"
import style0 from "./Modifypackage.vue?vue&type=style&index=0&id=0f3527ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports